import { Skeleton, Stack } from 'libs/ui';

export const SkeletonTable = () => (
  <Stack spacing={16}>
    <Skeleton animation="wave" height={50} variant="rounded" />
    <Skeleton animation="wave" height={300} variant="rounded" />
  </Stack>
);
